import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import VisibilityIcon from "@material-ui/icons/Visibility";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { formatDateTime } from "functions/Helper";
import { token } from "functions/Helper";
import { yuuApi } from "functions/apis";
import CustomInput from "components/CustomInput/CustomInput";
import { formatCurrency } from "functions/Helper";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const sortOptionList = [
  "NO_ASC",
  "NO_DESC",
  "CREATED_AT_ASC",
  "CREATED_AT_DESC"
];

const useStyles = makeStyles(styles);

export default function InEligibleList() {
  const inEligibleListSignal = React.useRef(new AbortController());

  const [filter, setFilter] = useState({
    searchString: null,
    status: 2,
    sort: 0
  });
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [data, setData] = useState([]);

  const getTransactionList = () => {
    setLoading(true);
    yuuApi
      .get("/Transactions", {
        signal: inEligibleListSignal.current.signal,
        params: {
          filter: filter,
          pagination: pagination
        }
      })
      .then(data => {
        setData(
          data.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  {(token["yuu.transactions.read"] === "allowed" ||
                    token.is_admin === "True") && (
                    <Link to={"/admin/YuuTransaction/Detail/" + record.id}>
                      <Button color="info" className="like">
                        <VisibilityIcon /> VIEW
                      </Button>
                    </Link>
                  )}
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
      })
      .catch(error => console.log(error))
      .finally(() => setLoading(false));
  };

  const handleSortOptionsChanged = e =>
    setFilter(prev => ({ ...prev, sort: e.target.value }));

  const handleSearchStringChanged = e =>
    setFilter(prev => ({ ...prev, searchString: e.target.value }));

  useEffect(() => {
    getTransactionList();

    return () => {
      inEligibleListSignal.current.abort();
    };
  }, []);

  useEffect(() => {
    getTransactionList();
  }, [filter, pagination]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4
              className={classes.cardIconTitle}
            >{`YUU TRANSACTION LIST - IN ELIGIBLE`}</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={6}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel htmlFor="selSort" className={classes.selectLabel}>
                    SORT BY
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    className={{
                      select: classes.select
                    }}
                    value={filter.sort ?? ""}
                    onChange={handleSortOptionsChanged}
                  >
                    {sortOptionList.map((record, idx) => {
                      return (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value={idx}
                          key={idx}
                        >
                          <p>{record.replaceAll("_", " ")}</p>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Search"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleSearchStringChanged,
                    value: filter.searchString ?? ""
                  }}
                />
              </GridItem>
            </GridContainer>
            <ReactTable
              manual
              pages={pages}
              pageSize={pagination.pageSize}
              page={pagination.pageIndex - 1}
              onPageChange={page => {
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                });
              }}
              onPageSizeChange={(pageSize, page) => {
                setPagination({ pageSize: pageSize, pageIndex: page + 1 });
              }}
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                {
                  Header: "Tomo ID",
                  accessor: "tomoId"
                },
                {
                  id: "createdAt",
                  Header: "Transaction Time",
                  accessor: d => formatDateTime(new Date(d.createdAt + "Z"))
                },
                {
                  id: "description",
                  Header: "Description",
                  accessor: d => d.description
                },
                {
                  id: "amount",
                  Header: "Amount",
                  accessor: d => formatCurrency("SGD", d.amount)
                },
                {
                  id: "pwpAmount",
                  Header: "PWP Amount",
                  accessor: d => formatCurrency("SGD", d.pwpAmount)
                },
                {
                  id: "paidAmount",
                  Header: "Paid Amount",
                  accessor: d => formatCurrency("SGD", d.paidAmount)
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
